import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { UserService } from '../../shared/user.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-patient-login',
  templateUrl: './patient-login.component.html',
  styleUrls: ['./patient-login.component.css']
})
export class PatientLoginComponent implements OnInit {

  showLodingSpinner: boolean;
  formSubmitted: boolean;
  @Output() change = new EventEmitter();
  isLoginError: boolean = false;
  UserCategory: any;
  data: any;
  USercatname: any;
  User_Cat :any;
  rf :any;
  constructor(private userService: UserService, private router: Router) {
    this.formSubmitted = false;
    this.showLodingSpinner = false;
  }

  ngOnInit() {
  }

  Login(form: NgForm) {
    debugger

    if(this.User_Cat!='Patient')
    {
      alert("Username is incorrect");
      this.rf.UserName= '';
      this.rf.Password= '';
    }
    if(this.User_Cat='Patient')
    if (!form.invalid) {      
      this.showLodingSpinner = true;
      this.userService.userAuthentication(form.value).subscribe((data: any) => {
        localStorage.setItem('accessToken', data.access_token);
        localStorage.setItem('userName', data.userName);
        this.GetAllowedPages();
      },
        (err: HttpErrorResponse) => {
          this.isLoginError = true;
          this.showLodingSpinner = false;
          alert("Username or password is not correct");
        });
    } else
      this.formSubmitted = true;
  }

  GetAllowedPages() {
    debugger
    this.userService.getAllowedPages().subscribe((data: any) => {
      localStorage.setItem('menuList', JSON.stringify(data));
      this.change.emit(false);
      if (data.length > 0)
        this.router.navigate([data[0].Menu_Redirect_URL]);
    },
      (err: HttpErrorResponse) => {
        alert("Failed!");
      });
  }


  GetByIdusercat(UserName) {
    alert(UserName);
    debugger;    
    this.UserCategory = this.userService.GetByIdusernam(UserName);
    this.UserCategory.subscribe(
      (response: any) => {
        this.USercatname = response;       
          this.User_Cat=response.User_Cat;
      }, (error) => {
      });
  }
}




// WEBPACK FOOTER //
// ./src/app/registration/patient-login/patient-login.component.ts